export default __webpack_public_path__ + "static/media/squares.6cf0ee96.svg";